import TaskIcon from '@/assets/icons/task-icon';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CrmTaskDTO } from '@/server/dto/crm-task-dto';
import { TraskCreateDialog } from './task-create-dialog';

export type TaskLinks = Pick<CrmTaskDTO['links'][0], 'modelId' | 'modelType' | 'title'>[];

type DropdownMenuItemCreateTaskProps = {
    links: TaskLinks;
};

export const DropdownMenuItemCreateTask = ({ links }: DropdownMenuItemCreateTaskProps) => {
    const { t } = useLocale();

    return (
        <DropdownMenuItem
            onSelect={() => {
                DialogStateManager.show(TraskCreateDialog, { links });
            }}
        >
            <TaskIcon className="h-4 w-4" />
            <span>{t('customer_detail__header__task', { ns: 'customer-detail' })}</span>
        </DropdownMenuItem>
    );
};
